export default class SafetyDataSheetSearchForm {

  private readonly id: JQuery;
  private readonly materialNumber: JQuery;
  private readonly submitBtn: JQuery;


  constructor(private form: JQuery) {

    this.id = this.form.find('.js-id');
    this.materialNumber = this.form.find('.js-materialNumber');
    this.submitBtn = this.form.find('.js-submitBtn');

    this.prepareForm();
    this.bindValidateForm();
  }

  bindValidateForm() {
    this.form.on('change', () => {
      this.prepareForm();
    });
  }

  prepareForm() {
    this.submitBtn.prop('disabled', !this.isFormValid());
  }

  isFormValid() {
    let isValid = false;

    if (this.id.val() !== '' || this.materialNumber.val() !== '') {
      isValid = true;
    }

    return isValid;

  }


}
